export const DICE_COUNT = 6;

export const DEFAULT_TARGET_SCORE = 4000;
export const MIN_TARGET_SCORE = 1000;
export const MAX_TARGET_SCORE = 10000;

export const ROOM_CODE_LENGTH = 4;
export const ROOM_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';

export const MAX_PLAYERS_PER_ROOM = 6;
export const MIN_PLAYERS_TO_START = 2;

export const SINGLE_ONE = 100;
export const SINGLE_FIVE = 50;

export const STRAIGHT_FULL = 1500;
export const STRAIGHT_2_6 = 750;
export const STRAIGHT_1_5 = 500;

export function tripleValue(face: number): number {
  return face === 1 ? 1000 : face * 100;
}

export function nOfAKind(face: number, count: number): number {
  if (count < 3) return 0;
  const triple = tripleValue(face);
  if (count === 3) return triple;
  if (count === 4) return triple * 2;
  if (count === 5) return triple * 4;
  return triple * 8;
}

export const RECONNECT_GRACE_MS = 60_000;
export const PING_INTERVAL_MS = 20_000;
